module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Mansfield\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Mansfield is a pseudonym of Paula Schwartz, which she used for more than two dozen Regency romances. Schwartz also wrote an American immigrant family saga, "), _c('I', [_vm._v("A Morning Moon")]), _vm._v(", as Paula Reibel, and two American history romances—"), _c('I', [_vm._v("To Spite the Devil")]), _vm._v(", as Paula Jonas, and "), _c('I', [_vm._v("Rachel’s Passage")]), _vm._v(", as Paula Reid."), _c('BR'), _vm._v("  "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mQu09W/tc-custom/9781497697720.jpg?1703646802700",
      "alt": "This image is the cover for the book Her Heart's Captain"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Heart's Captain\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Appearances can be deceiving in award-winning author Elizabeth Mansfield’s seductive Regency tale about a woman who loses her heart to the one man she has sworn never to love")]), _c('br'), _c('br'), _vm._v(" When Jenny Garvin arrives at the Portsmouth pier to see her adored brother sail off on one of His Majesty’s ships, she catches the eye of a tall, well-dressed stranger, who rescues her from a thief. But Captain Tristram Allenby is not what he seems. According to her brother, he is an icy-cold, monstrous tyrant who must be avoided at all costs."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Tris Allenby only has eyes for the spirited beauty who has haunted his dreams for the past six months. Now the most sought-after bachelor in London wants the one woman who will have nothing to do with him. The battle lines have been drawn—but there are always two winners in the intriguing game of love."), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0